<template>
  <section>
    <div class="row">
      <div class="col-md-6">
        <div class="numPad">
          <div class="buttons">
            <button type="button" v-for="button in buttons" :key="button" @click="addToExpression(button)">
              <b>{{ button }}</b>
            </button>
            <button type="button" class="clear" @click="clear"><b>C</b></button>
          </div>
        </div>
      </div>
      <div class="col-md-6 cash-screen">
        <h2 style="color: green"><b>Cash Taken</b></h2>
        <h2><b>{{cashTaken}}</b></h2>
        <h2 style="color: red">Cash Given</h2>
        <h2>{{cashGiven}}</h2>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  name: "PosCashTakenKeyPad",
  data() {
    return {
      cashTaken: 0,
      cashTakenIsLessThenBilledPrice: false
    };
  },

  props: {
    billedPrice: {
      type: Number,
      required: true,
    },
  },

  watch : {
    billedPrice: {
      handler(val) {
        this.cashTaken = val
      },
      immediate: true,
    },

    cashGiven: {
      handler(val) {
        if (val>0) {
          this.$emit('cashTaken', this.cashTaken)
        }
      },
      immediate: true,
    },

    cashTaken: {
      handler(val) {
        if (val>=0) {
          this.$emit('cashTaken', this.cashTaken)
        }
      },
      immediate: true,
    },
  },

  computed: {
    buttons() {
      return ['7', '8', '9', '4', '5', '6', '1', '2', '3', '0', '.'];
    },

    cashGiven() {
      const cashTakenNumber = Number(this.cashTaken);
      const billedPriceNumber = Number(this.billedPrice);

      if (this.cashTaken === '' || cashTakenNumber >= billedPriceNumber) {
        const change = (cashTakenNumber - billedPriceNumber).toFixed(2);
        return Number(change);
      } else {
        return 0;
      }
    }

  },

  methods: {
    addToExpression(button) {
      let cashTakenString = String(this.cashTaken);
      if (button === '.' && cashTakenString.includes('.')) {
        return;
      }
      if (cashTakenString === '0') {
        cashTakenString = '';
      }

      if (!cashTakenString.includes('.')) {
        if (cashTakenString.length < 9) {
          this.cashTaken = cashTakenString + button;
        }
      } else {
        let decimalPart = cashTakenString.split('.')[1];
        if (!decimalPart || decimalPart.length < 2) {
          this.cashTaken = cashTakenString + button;
        }
      }
    },


    clear() {
      this.cashTaken = 0;
    },

    setCashTaken(billedPrice) {
      this.cashTaken = billedPrice
    }
  }
}
</script>

<style scoped>
.numPad {
  padding: 10px;
  margin: 20px auto;
}

.buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}

button {
  width: 100px;
  height: 100px;
}

.clear {
  background-color: #fd9843;
}
.cash-screen {
  position: fixed;
  top: 20rem;
  right: 0;
}
</style>